var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41663 5.87884L7.26898 9.16667H5.56423L6.41663 5.87884Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2212 2.75741e-07H5.27881C4.54093 -8.89093e-06 3.93192 -1.81235e-05 3.43583 0.0405077C2.92057 0.0826102 2.44692 0.172957 2.00204 0.399649C1.31211 0.751181 0.751181 1.31211 0.399649 2.00204C0.172957 2.44692 0.0826102 2.92057 0.0405077 3.43583C-1.81235e-05 3.93192 -8.89092e-06 4.54091 2.75744e-07 5.2788V11.2212C-8.89092e-06 11.9591 -1.81235e-05 12.5681 0.0405077 13.0642C0.0826102 13.5794 0.172957 14.0531 0.399649 14.498C0.751181 15.1879 1.31211 15.7488 2.00204 16.1003C2.44692 16.327 2.92057 16.4174 3.43583 16.4595C3.93192 16.5 4.54091 16.5 5.27879 16.5H11.2212C11.9591 16.5 12.5681 16.5 13.0642 16.4595C13.5794 16.4174 14.0531 16.327 14.498 16.1003C15.1879 15.7488 15.7488 15.1879 16.1003 14.498C16.327 14.0531 16.4174 13.5794 16.4595 13.0642C16.5 12.5681 16.5 11.9591 16.5 11.2212V5.27879C16.5 4.54091 16.5 3.93192 16.4595 3.43583C16.4174 2.92057 16.327 2.44692 16.1003 2.00204C15.7488 1.31211 15.1879 0.751181 14.498 0.399649C14.0531 0.172957 13.5794 0.0826102 13.0642 0.0405077C12.5681 -1.81235e-05 11.9591 -8.89093e-06 11.2212 2.75741e-07ZM5.09621 3.66667H7.73703L10.1135 12.8333H8.21957L7.74428 11H5.08893L4.61362 12.8333H2.71968L5.09621 3.66667ZM12.8333 12.8333V3.66667H11V12.8333H12.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.19fb048f0b27f3908f76170571e5ecb4.svg";
export { ForwardRef as ReactComponent };